// 负责广告点击追踪
// iframe 相关的事件监听
// 页面可见性变化追踪
export default {
	data() {
		return {
			activeIframe: null,
			iframes: new Map(),
			checkInterval: null,
			visibilityChangeHandler: null,
		}
	},

	methods: {
		initAdTracking() {
			if (typeof window === 'undefined') return

			this.watchForIframeInsertion()
			this.setupVisibilityTracking()
		},

		watchForIframeInsertion() {
			const observer = new MutationObserver((mutations) => {
				mutations.forEach((mutation) => {
					mutation.addedNodes.forEach((node) => {
						if (node.tagName === 'IFRAME' && node.closest('ins.adsbygoogle')) {
							this.setupIframeTracking(node)
						}
					})
				})
			})

			observer.observe(document.body, {
				childList: true,
				subtree: true,
			})
		},

		setupIframeTracking(iframe) {
			if (this.iframes.has(iframe)) return

			this.iframes.set(iframe, {
				hasTracked: false,
				adSlot: iframe.closest('ins.adsbygoogle')?.dataset.adSlot,
			})

			iframe.addEventListener('focus', () => this.handleIframeFocus(iframe))
		},

		handleIframeFocus(iframe) {
			const data = this.iframes.get(iframe)
			if (!data?.hasTracked) {
				this.trackAdClick(iframe)
				data.hasTracked = true
				this.activeIframe = iframe
			}
		},

		trackAdClick(iframe) {
			const container = iframe.closest('ins.adsbygoogle')
			if (!container) return

			const rect = container.getBoundingClientRect()
			const clickData = {
				insX: rect.left,
				insY: rect.top,
				insHeight: rect.height,
				windowWidth: window.innerWidth,
				windowHeight: window.innerHeight,
				adSlot: container.dataset.adSlot,
			}

			this.$adClick?.(JSON.stringify(clickData))
			this.$eventrack?.('ad_iframe_click', 'click', {
				'data-ad-slot': clickData.adSlot,
			})
		},

		setupVisibilityTracking() {
			this.visibilityChangeHandler = () => {
				if (document.visibilityState === 'visible') {
					this.activeIframe = null
				} else if (this.activeIframe) {
					const data = this.iframes.get(this.activeIframe)
					this.$eventrack?.('ad_iframe_click_leave', 'click', {
						'data-ad-slot': data?.adSlot,
					})
				}
			}

			document.addEventListener('visibilitychange', this.visibilityChangeHandler)
		},

		cleanupAdTracking() {
			if (this.visibilityChangeHandler) {
				document.removeEventListener('visibilitychange', this.visibilityChangeHandler)
			}
			this.iframes.clear()
			this.activeIframe = null
		},
	},

	beforeDestroy() {
		this.cleanupAdTracking()
	},
}
